import axiosAuth from './axiosAuth'

export const getActions = (controller: AbortController) =>
    axiosAuth.get<string>('/actions', {
        signal: controller.signal,
    })

export const putActions = (data: string) => axiosAuth.put('/actions', data)
